import Resource from '@/api/resources/Resource'
import { SAMPLE_STATES } from '@/api/resources/entityState/sample-state'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class WasteSampleService extends Resource {
    async paginator(filterModel, params, laboratoryId, url) {
        const response =
            await this.axios.put(
                `/waste/laboratories/${laboratoryId}/cases/samples/${url}`,
                filterModel,
                { params })
        return response.data
    }

    async samplesSummary(labId) {
        return this.axios.get(`/waste/laboratories/${labId}/summary`).then(response => response.data)
    }

    async exportTo(laboratoryId, sectionLabel, filterModel, sortModel, columns, selectedIds, url, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `/waste/laboratories/${laboratoryId}/cases/samples/${url}/exportToPdf`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: selectedIds },
            { params, responseType: 'arraybuffer' })
    }

    async disposeOfSamples(labId, samples) {
        const params = toWasteSampleFamilyTrees(samples)
        const response = await this.axios.put(`/waste/laboratories/${labId}/samples/discard`, params)
        return response
    }

    async undoDisposeOfSamples(labId, samples) {
        const params = toWasteSampleFamilyTrees(samples)
        const response = await this.axios.put(`/waste/laboratories/${labId}/samples/undiscard`, params)
        return response
    }
}

export default new WasteSampleService()

// waste sample states
export const STATUS_OPTIONS_WASTE_SAMPLE = [
    SAMPLE_STATES.PROCESSED.code,
    SAMPLE_STATES.ARCHIVED.code,
    SAMPLE_STATES.DISCARDED.code
]

// "private" methods
function toWasteSampleFamilyTrees(samples) {
    return samples.map(sample => {
        return {
            caseId: sample.caseStudy.casId,
            sampleId: sample.samId
        }
    })
}
